$.inArrayRegEx = function(regex, array, start) {
	if( !array ) return -1;
	start = start || 0;
	for( var i = start; i < array.length; i++ ) {
		if( regex.test( array[i] ) ) {
			return i;
		}
	}
	return -1;
};

function winning_analyser( args ) {
	let that = this;
	// let winningAnalyzingCompleteEvent = new Event( 'winningAnalyzingCompleteEvent' );

	args = args || {};
	args.card = args.card || $('.card');
	args.card_header = args.card_header || ['B', 'I', 'N', 'G', 'O'];

	args.to_validate = args.to_validate || [];
	if( typeof( args.to_validate ) !== 'object' ) {
		args.to_validate = args.to_validate.split(" ");
	}

	args.mark_bingo = args.mark_bingo || false;

	args.remove_empty = args.remove_empty || false;

	// Winning type to check
	args.winning = args.winning || {};

	this.init = function() {
		let wins = this.look_for_win();

		if( args.mark_bingo ) { this.mark_bingos( wins ); }

		if( args.remove_empty === false ) {
			return wins;
		} else {
			let wins_trimmed = {},
				wins_keys = Object.keys(wins);

			for (let i = 0; i < wins_keys.length; i++) {
				let the_key = wins_keys[i];

				if( wins[ the_key ].length > 0 && wins[ the_key ] !== false ) {
					wins_trimmed[ the_key ] = wins[ the_key ];
				}
			}

			return wins_trimmed;

		}
	};

	this.look_for_win = function() {
		let wins = {};

		if( args.to_validate.length === 0 ) {
			for( const [winningTypeIndex, winningType] of Object.entries( args.winning )) {
				wins[winningType] = this.check_winning_way( winningType );
			}
		} else {
			for( const [winningTypeIndex, winningType] of Object.entries( args.winning )) {
				if( winningType !== 'full' ) {
					wins[winningType] = this.check_winning_way( winningType, args.to_validate[to_validate] );
				} else {
					wins[winningType] = this.check_full();
				}
			}
		}

		return wins;
	};

	// Ajouter les classes sur les bingos
	this.mark_bingos = function( wins ) {
		args.card.find('.case.bingo').removeClass('bingo');

		$.each(wins, function(wins_index, bingo_type) {
			$.each(bingo_type, function(bingo_type_index, to_mark_as_bingo) {
				if( to_mark_as_bingo !== 'full' ) {
					args.card.find('.case.' + to_mark_as_bingo).addClass('bingo');

					// Cas spécial pour le USA flag
					if( to_mark_as_bingo === 'usa_flag' ) {
						args.card.find('.case.' + to_mark_as_bingo).addClass('bingo-usa_flag');
					}
				} else {
					args.card.find('.case').addClass('bingo');
				}
			});

		});
	};

	this.check_winning_way = function( type, tovalidate ) {
		switch( type ) {
			case 'lines_vertical':
				wins = this.check_cols( tovalidate );
			break;

			case 'lines_horizontal':
				wins = this.check_rows( tovalidate );
			break;

			case 'diagonals':
				wins = this.check_diagonals();
			break;

			case 'full':
				wins = this.check_full();
			break;

			default:
				wins = this.check_standard( type );
			break;
		}

		return wins;
	};

	// Validation des lignes
	this.check_rows = function( to_validate ) {
		let wins = [];

		if( to_validate === undefined ) {
			for( var i = 1; i <= 5; i++ ) {
				if( args.card.find('.row-' + i + '.clicked').length == 5 ) {
					wins.push('row-' + i);
				}
			}
		} else {
			if( args.card.find('.' + to_validate + '.clicked').length == 5 ) {
				wins.push(to_validate);
			}
		}

		return wins;
	};

	this.check_cols = function( to_validate ) {
		let wins = [],
			nbCols = args.card_header.length;

		if( to_validate === undefined ) {
			for( var i = 0; i < nbCols; ++i ) {
				if( args.card.find('.column-' +  args.card_header[i] + '.clicked').length == 5 ) {
					wins.push('column-' + args.card_header[i]);
				}
			}
		} else {
			if( args.card.find('.' + to_validate + '.clicked').length == 5 ) {
				wins.push(to_validate);
			}
		}

		return wins;
	};

	this.check_diagonals = function() {
		let wins = [];

		if( args.card.find('.diagonal-ltr.clicked').length == 5 ) {
			wins.push('diagonal-ltr');
		}

		if( args.card.find('.diagonal-rtl.clicked').length == 5 ) {
			wins.push('diagonal-rtl');
		}

		return wins;
	};

	this.check_full = function() {
		let wins = [];

		if( args.card.find('.clicked').length == 25 ) {
			wins.push('full');
		}

		return wins;
	};

	this.check_standard = function( type ) {
		let wins = [];

		if( args.card.find('.' + type + '.clicked').length === args.card.find('.' + type ).length ) {
			wins.push( type );
		}

		return wins;
	};
}

export default winning_analyser;